import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {CommonModalComponent} from '../../../../shared/common-modal/common-modal.component';
import {TranslationService} from '../../../shared';
import {CubicleOption, EditOptionPayload} from '../../../../shared/model/cubicleOption-model';


@Component({
  standalone: false,
  selector: 'app-odm-edit-option-modal',
  templateUrl: './odm-edit-option-modal.component.html',
  styleUrls: ['./odm-edit-option-modal.component.less']
})
export class OdmEditOptionModalComponent {

  @Output()
  saveOption: EventEmitter<EditOptionPayload> = new EventEmitter<EditOptionPayload>();

  @ViewChild('editOptionModal', {static: false}) editOptionModal: CommonModalComponent;

  languages: string[];
  editOptionForm: EditOptionPayload = {id: '', name: {}, description: {}, rangeId: '', onPopUp: false, mandatory: false, nameKey: ''};
  option: CubicleOption;
  showOnPopupManagement = false;
  mandatory = false;

  constructor(private readonly translationService: TranslationService) {
  }

  showAddMode(languages: string[], showOnPopupManagement: boolean){
    this.showOnPopupManagement = showOnPopupManagement;

    this.editOptionForm.onPopUp = false;
    this.editOptionForm.mandatory = false;

    if(!showOnPopupManagement){
      this.editOptionForm.onPopUp = true;
    }
    this.languages = languages;
    this.languages.forEach(lang => {
      this.editOptionForm.name[lang] = null;
      this.editOptionForm.description[lang] = null;
    });
    this.editOptionModal.show();
  }

  showEditMode(option: CubicleOption, showOnPopupManagement: boolean){
    this.showOnPopupManagement = showOnPopupManagement;
    this.option = option;
    this.editOptionForm.onPopUp = option.onPopUp;
    this.editOptionForm.mandatory = option.mandatory;
    this.editOptionForm.id = option.id;
    this.translationService.getLocalesOfCountryOfKey(option.name).subscribe((locale => {
      locale.forEach(loc => {
        this.editOptionForm.name[loc.language] = loc.translations[0].translation;
      })
    }));

    this.translationService.getLocalesOfCountryOfKey(option.description).subscribe((locale => {
      locale.forEach(loc => {
        this.editOptionForm.description[loc.language] = loc.translations[0].translation;
      })
    }));

    this.editOptionModal.show();
  }

  hide() {
    this.editOptionModal.hide();
  }

  isValidForm(): boolean {
    for (let key in this.editOptionForm.name) {
      if(!this.editOptionForm.name[key]){
        return false;
      }
    }
    for (let key in this.editOptionForm.description) {
      if(!this.editOptionForm.description[key]){
        return false;
      }
    }
    return !(this.editOptionForm.onPopUp && this.editOptionForm.mandatory);
  }


  clickOnSaveOption() {
    const editPayload: EditOptionPayload = {
      id: this.editOptionForm.id,
      name: this.editOptionForm.name,
      description: this.editOptionForm.description,
      rangeId : this.editOptionForm.rangeId,
      nameKey: '',
      onPopUp: this.editOptionForm.onPopUp,
      mandatory: this.editOptionForm.mandatory};
    if (this.option != null) {
      editPayload.nameKey = this.option.name;
    }
    this.saveOption.emit(editPayload);
  }

  // function for the ngfor + ngmodel, so it doesn't lose focus
  trackByFn(index, item): number {   return index; }

  /**
   * Update the option flags based on the changed field.
   * @param changedField
   */
  updateOptionFlags(changedField: 'onPopUp' | 'mandatory') {
    if (changedField === 'onPopUp' && this.editOptionForm.onPopUp) {
      this.editOptionForm.mandatory = false;
    }
    if (changedField === 'mandatory' && this.editOptionForm.mandatory) {
      this.editOptionForm.onPopUp = false;
    }
  }
}
